import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const PHONE_ANSWERING_TAGS = {
  STORE: 'store',
  OCC_PHONE_NUMBERS: 'occ_phone_numbers',
};

export const phoneAnsweringApiSlice = createApi({
  reducerPath: 'phoneAnsweringApiSlice',
  tagTypes: Object.values(PHONE_ANSWERING_TAGS),
  baseQuery,
  endpoints: (builder) => ({
    getPhoneAnsweringData: builder.query({
      query: ({ apiManager, ...rest }) => apiManager.get(rest),
      providesTags: [PHONE_ANSWERING_TAGS.STORE],
    }),
    updatePhoneAnswering: builder.mutation({
      query: ({ apiManager, ...rest }) => apiManager.update(rest),
      invalidatesTags: [PHONE_ANSWERING_TAGS.STORE],
    }),
    createPhoneAnswering: builder.mutation({
      query: ({ apiManager, ...rest }) => apiManager.create(rest),
      invalidatesTags: [PHONE_ANSWERING_TAGS.STORE, PHONE_ANSWERING_TAGS.OCC_PHONE_NUMBERS],
    }),
    getOccPhoneNumbers: builder.query({
      query: ({ apiManager, ...rest }) => apiManager.getPhoneNumbers(rest),
      providesTags: [PHONE_ANSWERING_TAGS.OCC_PHONE_NUMBERS],
    }),
  }),
  serializeQueryArgs,
});

export const {
  useGetPhoneAnsweringDataQuery,
  useGetOccPhoneNumbersQuery,
  useLazyGetOccPhoneNumbersQuery,
  useUpdatePhoneAnsweringMutation,
  useCreatePhoneAnsweringMutation,
} = phoneAnsweringApiSlice;
